import './index.less';

type RevxLogo = 'blue' | 'red' | 'yellow' | 'black' | 'gray' | '';

type RevxLogoTextProps = {
  text: string;
  colors: RevxLogo[];
};

const RevxLogoText = ({ text, colors }: RevxLogoTextProps) => {
  return (
    <div className="revx-logo-text">
      {text.split('').map((char, index) => {
        return (
          <span key={index} className={colors[index] || ''}>
            {char}
          </span>
        );
      })}
    </div>
  );
};

export default RevxLogoText;
